const apiGestaoSSApiUrl = `https://app3.sestsenat.org.br/gestaoss/api/`;
const apiGestaoSSUrl = `https://app3.sestsenat.org.br/gestaoss/`;
const urlApi = `https://empregonapista.sestsenat.org.br/api/`;
const urlVersionFile = `https://empregonapista.sestsenat.org.br/version.json`;
const urlApiLGPD = `https://lgpd.sestsenat.org.br`;

export const environment = {
  production: false,
  apiGestaoSSApiUrl,
  apiGestaoSSUrl,
  urlApi,
  urlVersionFile,
  urlApiLGPD
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts